fragment DepartmentFields on Department {
  id
  name
  description
  _rowTimestamp
  _isUpdatable
  _isDeletable
}
